import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectCurrentPageEntities} from '@ngneat/elf-pagination';

import {suppliersStore} from '@store/suppliers/suppliers.store';

export const getSuppliersDataSource = createRequestDataSource({
  store: suppliersStore,
  data$: () => suppliersStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getSuppliers',
  dataKey: 'suppliers',
});